<template lang="pug">
.card(:class="{ 'card--locked': false }")
  .card__head
    .card__step(v-html="`${$t('promo.challenges.step')} ${step}`")
    .card__name(v-html="data.label")
  .card__body
    .card__place(v-html="calculatedPlaceText")
    .card__number(v-html="calculatedPosition")
  .card__bottom
    .card__coins(v-html="data.reward_points")
    .card__status(:class="calculatedStatus.class" v-html="calculatedStatus.text")
</template>

<script>
export default {
  name: "ChallengeCard",
  props: {
    step: {
      type: Number,
      default: null,
    },
    data: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      timesCompletedThreshold: 10000,
    }
  },
  computed: {
    calculatedPlaceText() {
      if (this.data.position !== null) {
        return this.$t("promo.challenges.your_place");
      }

      return this.$t("promo.challenges.finished");
    },
    getTimesCompleted() {
      return this.data.times_completed <= this.timesCompletedThreshold ? this.data.times_completed : `${this.timesCompletedThreshold}+`;
    },
    calculatedPosition() {
      return this.data.position || this.getTimesCompleted;
    },
    calculatedStatus() {
      if (this.data.reward_points === 0) {
        return {
          text: this.$t("promo.challenges.prize_not_received"),
          class: "card__status--error",
        }
      }

      if (this.data.position !== null && this.data.reward_points !== 0) {
        return {
          text: this.$t("promo.challenges.prize_received"),
          class: "card__status--success",
        }
      }

      return {
        text: "",
        class: "",
      }
    },
  },
};
</script>
